export default __webpack_public_path__ + "static/media/LSP7.7867493e.png";